import { FC } from 'react'
import { Select, SelectProps, Tag } from 'antd'
import type { CustomTagProps } from 'rc-select/lib/BaseSelect'
import { DownMini } from '../../../../assets/icons'
import style from './style.m.less'
import { colorPicker } from '../../../helpers'

interface ITagSelector extends SelectProps {
    customStyle?: React.CSSProperties
    value?: number[]
    showSearch?: boolean
    onChange?(value: number[]): void
    currentLang?: string
}

interface IPowerTypeTag {
    value: number
    customStyle?: React.CSSProperties
    color: string
}

const PowerTypeTag: FC<IPowerTypeTag> = ({ children, color, customStyle }) => {
    return (
        <Tag color={color} style={customStyle} className={style.typeTag}>
            {children}
        </Tag>
    )
}

const tagRender = (props: CustomTagProps) => {
    const { label, value } = props

    return (
        <PowerTypeTag
            value={value}
            color={colorPicker(label as string)}
            customStyle={{ marginRight: 8 }}
        >
            {label}
        </PowerTypeTag>
    )
}

const TagSelector: FC<ITagSelector> = ({ customStyle, options, value, showSearch, onChange, currentLang }) => {
    const localizedOptions = options.map((opt) => ({
        id: opt.id,
        value: opt.value,
        text: opt.texts[currentLang] || opt.text,
        label: opt.labels[currentLang] || opt.label,
    }));


    return (
        <Select
            mode="multiple"
            showArrow
            suffixIcon={
                <div style={{ marginTop: '4px', marginRight: '3px' }}>
                    <DownMini />
                </div>
            }
            allowClear
            style={customStyle}
            tagRender={tagRender}
            className={style.typeSelector}
            options={localizedOptions}
            value={value}
            onChange={onChange}
            showSearch={showSearch}
        />
    )
}

export default TagSelector
